"use strict";
exports.__esModule = true;
var stringConstructor = 'test'.constructor;
var arrayConstructor = [].constructor;
var objectConstructor = {}.constructor;
function getDataType(object) {
    if ((object === null || object === void 0 ? void 0 : object.constructor) === stringConstructor) {
        return 'string';
    }
    if ((object === null || object === void 0 ? void 0 : object.constructor) === arrayConstructor) {
        return 'array';
    }
    if ((object === null || object === void 0 ? void 0 : object.constructor) === objectConstructor) {
        return 'object';
    }
}
function logMaskPhone(s) {
    var data = s.trim();
    var start = data.indexOf(':');
    if (start === -1) {
        return data;
    }
    return data.substring(0, start + 2) + data.substring(data.length - 4);
}
/**
 * Array of keywords that are used to locate keys on a json object.  If any of these are found, the resulting
 * value will be empty.
 * These values should be lowercase.
 * @type {string[]}
 */
var cleanKeywordList = [
    'propertyaddress',
    'propertyname',
    'property_name',
    'location',
    'addressline1',
    'addressline2',
    'city',
    'state',
    'postalcode',
    'country',
    'address',
    'placeaddress',
    'billingdetails',
    'geopoint',
    'geohash',
    'extracted',
    'formatted',
    'unitcode',
    'verificationcode',
    'enteredquery',
    'query',
    'contact',
    'first',
    'first_name',
    'last',
    'last_name',
    'ssn',
    'email',
    'unit',
    'dob',
    'ip',
];
/**
 * Content used to search for a substring that contains data that should be removed or masked.
 * The key's for this object must be lower case for matching purposes.
 * @type {{"requesting a code to phone": ((function(*): (*))|*), "sms sent to phone": ((function(*): (*))|*), phonenumber: ((function(*): (*))|*)}}
 */
var stringCheckList = {
    phonenumber: logMaskPhone,
    phone: logMaskPhone,
    'device key "phone" set to': logMaskPhone
};
/**
 * Copy the content passed in through the data argument, if the data is an object or array, while also using keys
 * on an object to determine if a key/value should be part of the result.  The intent of this process is to
 * reduce the likelihood of data showing up in logs that shouldn't be recorded.  This can be a recursive call
 * and recursion will take place when parsing an object that contains other objects.
 * @param data
 * @param objPath
 * @returns {{}|*[]|*}
 */
function cleanLogData(data, objPath) {
    if (objPath === void 0) { objPath = ''; }
    var dataType = getDataType(data);
    // Return the value if this isn't an array or object because we aren't checking values, currently
    // only looking at keys in key/value pairs of objects.
    // If the value is a string, check for keys from the stringCheckList and if found, execute the related
    // function call on the data.
    if (!dataType || (dataType !== 'array' && dataType !== 'object')) {
        if (dataType === 'string') {
            for (var _i = 0, _a = Object.entries(stringCheckList); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (data.toLowerCase().indexOf(key) !== -1) {
                    return value(data);
                }
            }
        }
        return data;
    }
    // For arrays, check each element using recursion, looking for objects to validate.
    if (dataType === 'array') {
        var arr_1 = [];
        data.forEach(function (element) {
            try {
                arr_1.push(cleanLogData(element, objPath));
            }
            catch (e) {
                // It might be good to log this failure, however, this may also generate a lot of noise
                // in logs and will initially exclude any action from taking place.
            }
        });
        return arr_1;
    }
    else {
        // object handler
        // If a key is within the cleanKeywordList array the result is an empty value.
        // However, if it isn't, parsing has to continue on and we'll make use of recursion to look at each
        // element of the object and potentially the children.  This is performing a deep copy as the key/value
        // pairs are added to the newObj var as they are encountered and validated.
        var newObj = {};
        for (var _c = 0, _d = Object.entries(data); _c < _d.length; _c++) {
            var _e = _d[_c], key = _e[0], value = _e[1];
            try {
                if (cleanKeywordList.indexOf(key.toLowerCase()) === -1) {
                    var tmpObj = cleanLogData(value, objPath !== '' ? "".concat(objPath, ".").concat(key) : key);
                    var dataType_1 = getDataType(tmpObj);
                    if (dataType_1 && dataType_1 === 'object') {
                        if (Object.keys(tmpObj).length > 0) {
                            newObj[key] = tmpObj;
                        }
                    }
                    else {
                        newObj[key] = tmpObj;
                    }
                }
            }
            catch (e) {
                // Same as for array handling of errors, unless there is a need to log the error the noise
                // that would possibly be generated may make it pointless to provide logging here.
            }
        }
        return newObj;
    }
}
exports["default"] = cleanLogData;
